import SliderGeneral from './SliderGeneral';

const $ = jQuery;

export default class SliderMobile extends SliderGeneral {
    constructor(selector) {
        super(selector);
    }

    _init() {
        this.mobileSlider = [];
        this.isActive = false;

        if (this._isMobileView()) {
            this._initSlider();
        }

        this._addEventListener();
    }

    _addEventListener() {
        $(window).on('resize', () => { this._resizeCallback(); });
    }

    _resizeCallback() {
        if (this._isMobileView() && !this.isActive) {
            this._initSlider();
        } else if (!this._isMobileView() && this.isActive) {
            this._destroySlider();
        }
    }

    _initSlider() {
        this.isActive = true;

        $(this.selector).each((index, element)=>{
            let settings = Object.assign({}, this.originalSettings);
            this.mobileSlider.push(new Swiper (element, settings));
        });
    }

    _destroySlider() {
        this.mobileSlider.forEach((slider)=>{
            slider.destroy(true, true);
        });
        this.mobileSlider.length = 0;
        this.isActive = false;
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/SliderMobile.js